module.exports = __webpack_public_path__ + "img/7-Orig-Low.b3be9af5.jpg";